module.exports = __webpack_public_path__ + "img/28_64.5529bade.png";